import React, { useState } from "react";
import Layout from "../../components/Layout/Layout";
import CircleSlider from "./CircleSlider";
import "./StepSlider.css";
import logo from "../../images/logo_largo_blanco.png";
import { NavLink } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { BiChevronRight } from "react-icons/bi";
const StepSliderContainer = ({ steps }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [ back, setBack ] = useState(false);

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
      setBack(true);
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
      setBack(false);
    }
  };
  return (
    <div>
      <Layout>
        <div className="stepsContainer">
          <NavLink to="/generate" className="omitir-btn">
            Omitir
            <IoIosArrowForward style={{ fontSize: "10px" }} />
          </NavLink>
          <div className="stepBox">
            <div className="stepurlContain">
              <img
                src={steps[currentStep].url}
                alt="stepImg"
                className="stepImg"
              />
            </div>
            <div className="container-steplider">
              <img
                src={steps[currentStep].imgNumber}
                alt="imgNumber"
                className="numberStep"
              />
              <p className="step-paragraph">{steps[currentStep].text}</p>
            </div>
            <div className="contentButton">
              {currentStep === steps.length - 1 ? (
                <NavLink to="/generate" className="button-siguiente">
                  {steps[currentStep].button}
                  {steps[currentStep].icon}
                </NavLink>
              ) : (
                <>
                  {
                    back && (
                    <button className='button-back' onClick={() => handleBack()}>
                      <BiChevronRight style={{rotate:'180deg',fontSize:'24px'}}/>
                    Volver
                     </button>
                  )}
                  <button
                    className="button-siguiente"
                    onClick={() => handleNext()}
                  >
                    {steps[currentStep].button}
                    {steps[currentStep].icon}
                  </button>
                </>
              )}
            </div>
          </div>
          <CircleSlider steps={steps} currentStep={currentStep} />
          <img src={logo} alt="" className="logoStepsSlider" />
        </div>
      </Layout>
    </div>
  );
};

export default StepSliderContainer;
